import React from 'react';

export const Expand = () => (
    <g>
        <path d='M16.5,12H7c-0.276,0-0.5,0.224-0.5,0.5S6.724,13,7,13h9.5c0.276,0,0.5-0.224,0.5-0.5S16.776,12,16.5,12z' />
        <path d='M14.146,20.146L12,22.293V15.5c0-0.276-0.224-0.5-0.5-0.5S11,15.224,11,15.5v6.793l-2.146-2.146
			c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l3,3c0.195,0.195,0.512,0.195,0.707,0l3-3
			c0.195-0.195,0.195-0.512,0-0.707S14.342,19.951,14.146,20.146z' />
        <path d='M8.854,3.854L11,1.707V8.5C11,8.776,11.224,9,11.5,9S12,8.776,12,8.5V1.707l2.146,2.146c0.195,0.195,0.512,0.195,0.707,0
			s0.195-0.512,0-0.707l-3-3c-0.195-0.195-0.512-0.195-0.707,0l-3,3c-0.195,0.195-0.195,0.512,0,0.707S8.658,4.049,8.854,3.854z' />
    </g>
);